import { CouponApplyErrorCode } from "../core/enums";
import { StatelessCart } from "../models/carts/cart-stateless";
import { CouponFactory } from "./coupon-factory";
export class CouponManager {
    _appType;
    _sourceData;
    _dependencies;
    constructor(adapter) {
        const { appType, sourceData, dependencies } = adapter.bootstrap();
        this._appType = appType;
        this._sourceData = sourceData;
        this._dependencies = dependencies;
    }
    /**
     * Engine tracing. Silent unless the host supplied `isDevelopmentMode` and it
     * returns true — the library is embedded in production storefronts and tills,
     * so console output is opt-in, never the default.
     */
    _log(message) {
        if (this._dependencies.isDevelopmentMode?.())
            console.log(message);
    }
    getPricePreviewForCoupon(coupon, cartSnapshot) {
        // Build a sandbox stateless cart (mutates only a local clone, records a patch)
        const cart = new StatelessCart(cartSnapshot);
        const couponInstance = CouponFactory.createCoupon(this._appType, this._sourceData, this._dependencies, coupon);
        if (!couponInstance)
            return 0;
        const qualifiedList = couponInstance.getQualifiedDiscountItems(cart);
        let qualifiedItemsRegularPrice = qualifiedList.reduce((sum, item) => sum + (item.oPrice), 0);
        const [discountAmount] = couponInstance.calculateDiscount(cart);
        return qualifiedItemsRegularPrice - discountAmount;
    }
    apply(coupon, cartSnapshot, identity) {
        // Build a sandbox stateless cart (mutates only a local clone, records a patch)
        const cart = new StatelessCart(cartSnapshot);
        if (!cart.isCartValid()) {
            return {
                success: false,
                errorCode: CouponApplyErrorCode.CART_TOTAL_IS_ZERO,
            };
        }
        const couponInstance = CouponFactory.createCoupon(this._appType, this._sourceData, this._dependencies, coupon, identity);
        if (!couponInstance) {
            return {
                success: false,
                errorCode: CouponApplyErrorCode.COUPON_TYPE_NOT_SUPPORTED,
            };
        }
        this._log(`Start applying coupon...`);
        const preResult = couponInstance.meetsPreConditions(cart);
        if (!preResult.isValid) {
            this._log(`Coupon does not meet conditions.`);
            return {
                success: false,
                errorCode: preResult.errorCode,
            };
        }
        const [discountAmount, discountItems] = couponInstance.calculateDiscount(cart);
        cart.addDiscountToCart(couponInstance, discountItems, discountAmount);
        // Post-process the cart items based on whether the minimum order amount is still met
        const postResult = couponInstance.meetsPostConditions(cart);
        if (!postResult.isValid) {
            return {
                success: false,
                errorCode: postResult.errorCode,
            };
        }
        return {
            success: true,
            data: {
                discountAmount: discountAmount,
                addDiscounts: discountItems
            },
            patch: cart.patch
        };
    }
}
//# sourceMappingURL=coupon-manager.js.map